import React, { useContext } from "react";
import { Preview } from "@creatomate/preview";
import { Icon, PlainButton } from "@culturehq/components";
import { MediaVersion } from "chq";
import { CreatomateContext } from "../../contexts/VideoStudioContext";
import { needToBlockSubtitles } from "../../sidebar/tabs/subtitle/utils";

interface UndoButtonProps {
  preview: Preview;
}

const UndoButton: React.FC<UndoButtonProps> = ({
  preview
}) => {
  const { data, handleUpdateData } = useContext(CreatomateContext);
  const { lastMediaVersion } = data;

  const handleUndo = async () => {
    await preview.undo();
    const source = preview.getSource();
    handleUpdateData({
      blockSubtitles: needToBlockSubtitles(source, lastMediaVersion as MediaVersion)
    });
  };

  return (
    <PlainButton className="Undo-Btn" onClick={handleUndo} disabled={!preview.state?.undo}>
      <Icon className="Undo-Icon" icon="linkedin-share" />
    </PlainButton>
  );
};

export default UndoButton;
